import "../../sass/layout/carrousel/carrousel.css";
import { Button, Col, Container, Row } from "react-bootstrap";
import upArrow from "../../utils/img/right-arrow.png";
import { useSelector } from "react-redux";
import { Mixpanel } from "../../utils/mixpanelIntegration";
import { useCarouselSlides } from "../../hooks/carousel/useCarousel";
import { useCarouselSpeed } from "../../hooks/carousel/useCarouselSpeed";
import { useCarouselClicked } from "../../hooks/carousel/useCarouselClicked";
import UserService from '../../services/api/UserService';
import { useEffect, useState } from "react";

const Carrousel = ({ retireeId }) => {
  const location = useSelector((state) => state.homeReducer.location?.data);
  const tokenMedia = useSelector((state) => state.homeReducer.tokenMedia);
  const memberID = location?.uniqueNonGuessableId;
  const carouselSpeed = useCarouselSpeed(false); // Always get proper carousel speed from API
  const carouselSlides = useCarouselSlides(retireeId ? null : memberID);
  const [retireeCarouselSlides, setRetireeCarouselSlides] = useState([]);

  const fetchRetireeCarousel = async (retireeId) => {
    if (!retireeId) return;
    
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const requestOptions = {
        method: "GET",
        redirect: "follow"
      };
      
      const response = await fetch(`${API_URL}api/retiree/${retireeId}/carrousel`, requestOptions);
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const result = await response.json();
      setRetireeCarouselSlides(result.data || []);
    } catch (error) {
      console.error("Error fetching retiree carousel:", error);
      setRetireeCarouselSlides([]);
    }
  };

  useEffect(() => {
    if (retireeId) {
      fetchRetireeCarousel(retireeId);
    }
  }, [retireeId]);

  const activeSlides = retireeId ? retireeCarouselSlides : carouselSlides;
  const [clicked, setClicked] = useCarouselClicked(activeSlides, carouselSpeed);


  const showData = activeSlides?.find((slide) =>
    clicked != null
      ? slide?.id === clicked
      : slide?.id === activeSlides[0]?.id
  );

  const imageUrl = showData?.attributes?.image?.data?.attributes?.url || showData?.image?.url
  const style = {
    background: `url(${imageUrl}?${tokenMedia})`,
  };


  const getSlideUrl = (slide) => {
    const url = slide?.attributes?.file?.url || slide?.attributes?.url || slide?.url || slide?.file?.url;
    // If the link is a link to a file in the miia private azure storage system it needs a tokenMedia to get access
    // If the link is not a link to a file in the miia private azure storage system it should not have the tokenMedia
    // Links to private files have this structure name.blob.core.windows....
    const isLinkToPrivateFile = decodeURIComponent(url).includes("blob.core.windows");
    return`${url?.startsWith("http") ? "" : "https://"}${url}${isLinkToPrivateFile ? "?" +  tokenMedia : ""}`;
  }

  return (
    <Container fluid className="carrousel-home-container">
      {activeSlides?.length > 0 && (
        <Col className="carrousel-images-container" style={style}>
          <Row className="carrousel-content-card">
            <a
              href={getSlideUrl(showData)}
              target="_blank"
              className="a-carrousel-link"
              rel="noreferrer"
              onClick={() => {
                Mixpanel.track("Carousel Clicked", {
                  "Carousel Title": showData?.attributes.title,
                  locationName: location?.name,
                });
              }}
            >
              <Col className="carrousel-text">
                <h5 className="h5-carrousel">
                  <strong>{showData?.attributes?.title}</strong>
                </h5>
                <p className="description-view">
                  {showData?.attributes?.description}
                </p>
              </Col>
              <Col className="see-more">
                <img
                  className="arrow-right"
                  alt="next slide"
                  src={upArrow}
                ></img>
              </Col>
            </a>
          </Row>
          <Container fluid className="carrousel-pagination-card">
            {activeSlides?.map((element) => {
              return (
                <Button
                  key={element?.id}
                  value={element?.id || activeSlides[0]?.id}
                  onClick={(e) => setClicked(parseInt(e.target.value))}
                  bsPrefix="carrousel-btns"
                  style={
                    clicked === element?.id
                      ? { backgroundColor: "#1A1919" }
                      : {}
                  }
                />
              );
            })}
          </Container>
        </Col>
      )}
    </Container>
  );
};

export default Carrousel;
